<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card no-body>
                <b-card-body style="display:flex;align-items:center;">
                    Selamat datang di aplikasi Penjualan Sinar Mutiara!
                    <b-button variant="outline-primary" class="mr-2" style="margin-left:auto;" @click="onClickShowCatalog">
                        Tampilkan Katalog
                    </b-button>
                    <b-button v-if="roleId == 1" variant="primary" @click="prepareUpdate">
                        <!-- Update Katalog <b-badge variant="light">{{ counts.pending_public }}</b-badge> -->
                        Update Katalog
                    </b-button>
                </b-card-body>
            </b-card>
            <b-row>
                <b-col sm="12" lg="3">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5><i class="fa fa-fw fa-arrow-left mr-2" />Kirim Balik PGI</h5>
                        </div>
                        <hr class="my-2" />
                        <div class="brand-card-body" style="padding: 0">
                            <div>
                                <div class="text-value">{{ counts.send_back.pending }}</div>
                                <div class="text-uppercase text-muted small">PENDING</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.send_back.otw }}</div>
                                <div class="text-uppercase text-muted small">PERJALANAN</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm="12" lg="6">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5><i class="fa fa-fw fa-cubes mr-2" />Inventory</h5>
                        </div>
                        <hr class="my-2" />
                        <div class="brand-card-body" style="padding: 0">
                            <div>
                                <div class="text-value">{{ counts.inventory.pending }}</div>
                                <div class="text-uppercase text-muted small">PENDING APPROVAL</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.inventory.adj }}</div>
                                <div class="text-uppercase text-muted small">BUTUH ADJ. BARCODE</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.inventory.req_lost }}</div>
                                <div class="text-uppercase text-muted small">REQUEST HILANG</div>
                            </div>
                            <div>
                                <div class="text-value" style="color: red">{{ counts.inventory.retur_reset }}</div>
                                <div class="text-uppercase text-muted small">RETUR RESET</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm="12" lg="3">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5><i class="fa fa-fw fa-file mr-2" />Invoice</h5>
                        </div>
                        <hr class="my-2" />
                        <div class="brand-card-body" style="padding: 0">
                            <div>
                                <div class="text-value">{{ counts.invoice.draft }}</div>
                                <div class="text-uppercase text-muted small">DRAFT</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.invoice.ongoing }}</div>
                                <div class="text-uppercase text-muted small">ONGOING</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <!-- <b-col lg="4" sm="6" xs="12">
                    <b-card no-body footer-class="px-3 py-2">
                        <b-card-body class="p-3 clearfix">
                            <i class="fa fa-truck bg-dark p-3 font-2xl mr-3 float-left"></i>
                            <div class="h5 mb-0 mt-2">2</div>
                            <div class="text-muted text-uppercase font-weight-bold font-xs">Request Kirim Balik PGI</div>
                            <div class="text-right mt-3">
                            <b-btn size="sm" variant="primary">Manage</b-btn>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col> -->
            </b-row>
            <b-card>
                <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Barang Pending</h5>
                <hr />
                <b-row>
                    <b-col md="3">
                        <b-form-group label="No. Faktur PGI">
                            <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="IMEI / SN">
                            <b-form-input v-model="filter.imeiSn" maxlength="100" @keydown.enter="getItems" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Cabang">
                            <b-form-input v-model="filter.branch" maxlength="5" @keydown.enter="getItems" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Aksi">
                            <b-button variant="primary" @click="getItems()">
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-table bordered hover show-empty no-local-sorting
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    @sort-changed="onSortChanged"
                    responsive class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada data barang.
                    </template>
                    <template v-slot:cell(item)="row">
                        {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                        <div class="small text-muted">
                            {{ row.item.kind }} - {{ row.item.brand }}
                        </div>
                    </template>
                </b-table>
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
            </b-card>

<!--             <tableau-viz id='tableau-viz' src='https://prod-apsoutheast-a.online.tableau.com/t/ekasatria/views/testworkbook/Sheet1' toolbar='bottom' v-if="roleId == 1" /> -->
        </div>

        <b-modal id="m-update" title="Update Katalog" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-alert show>
                Update Katalog Terakhir :
                <li v-for="(item, index) in catalogLogs" :key="'catalog-log-' + index" class="mb-2">
                    {{ $helper.parseDate(item.run_at) }} {{ $helper.parseHourMinute(item.run_at) }} <strong>({{ item.run_by.fullname }})</strong>
                    <div class="small text-muted" style="margin-left:20px">Office : 
                        <span v-if="item.office_name == null">-</span>
                        <span v-else>{{ item.office_name }}</span>
                    </div>
                    <div class="small text-muted" style="margin-left:20px">Divisi : 
                        <span v-if="item.division_name == null">-</span>
                        <span v-else>{{ item.division_name }}</span>
                    </div>
                    <div class="small text-muted" style="margin-left:20px">Periode Approve <strong>Lengkap</strong> : 
                        <span v-if="item.start_date_lengkap == null && item.end_date_lengkap == null">-</span>
                        <span v-else>{{ $helper.parseDate(item.start_date_lengkap) }} - {{ $helper.parseDate(item.end_date_lengkap)}}</span>
                    </div>
                    <div class="small text-muted" style="margin-left:20px">Periode Approve <strong>Batangan</strong> : 
                        <span v-if="item.start_date_batangan == null && item.end_date_batangan == null">-</span>
                        <span v-else>{{ $helper.parseDate(item.start_date_batangan) }} - {{ $helper.parseDate(item.end_date_batangan)}}</span>
                    </div>
                </li>
            </b-alert>

            <hr />
            <div class="mt-4">
                <div>
                    <strong>Lokasi Office :</strong>
                    <b-form-select class="mt-1"
                        v-model="catalogOffice"
                        value-field="id"
                        text-field="name"
                        :options="optOffice"
                        @change="clearUpdateCatalog"
                    />
                </div>
                <div class="mt-3">
                    <strong>Divisi Barang :</strong>
                    <b-form-select class="mt-1"
                        v-model="catalogDivision"
                        value-field="id"
                        text-field="name"
                        :options="optDivision"
                        @change="clearUpdateCatalog"
                    />
                </div>
                <div class="mt-3">
                    <strong>Periode Approve Barang (Lengkap) :</strong>
                    <b-row class="mt-1">
                        <b-col>
                            <b-form-group label="Dari">
                                <b-form-input type="date" v-model="startDateLengkap" @change="runCountCatalogLengkap" />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Sampai">
                                <b-form-input type="date" v-model="endDateLengkap" @change="runCountCatalogLengkap" />
                            </b-form-group>
                        </b-col>
                    </b-row>                    
                </div>
                <div>
                    <strong>Periode Approve Barang (Batangan) :</strong>
                    <b-row class="mt-1">
                        <b-col>
                            <b-form-group label="Dari">
                                <b-form-input type="date" v-model="startDateBatangan" @change="runCountCatalogBatangan" />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Sampai">
                                <b-form-input type="date" v-model="endDateBatangan" @change="runCountCatalogBatangan" />
                            </b-form-group>
                        </b-col>
                    </b-row>                    
                </div>
            </div>
            <div v-if="(!$helper.isBlank(startDateLengkap) && !$helper.isBlank(endDateLengkap)) || (!$helper.isBlank(startDateBatangan) && !$helper.isBlank(endDateBatangan))">
                Apakah anda yakin ingin melakukan update katalog?</br>
                <p class="mb-0" v-if="!$helper.isBlank(startDateLengkap) && !$helper.isBlank(endDateLengkap)">Sebanyak <strong>{{ catalogCountLengkap }} barang baru (Lengkap)</strong> akan ditampilkan untuk publik!</p>
                <p v-if="!$helper.isBlank(startDateBatangan) && !$helper.isBlank(endDateBatangan)">Sebanyak <strong>{{ catalogCountBatangan }} barang baru (Batangan)</strong> akan ditampilkan untuk publik!</p>
            </div>
            <div class="mt-4 text-right">
                <b-button variant="outline-primary" class="mr-2" :disabled="isBusy" @click="$bvModal.hide('m-update')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isBusy || (startDateLengkap == null && endDateLengkap == null && startDateBatangan == null && endDateBatangan == null)" @click="confirmUpdate">
                    {{ isBusy ? "Mengupdate..." : "Update Katalog" }}
                </b-button>
            </div>
        </b-modal>
<!--         <tableau-viz id="tableauViz"       
            src='https://prod-apsoutheast-a.online.tableau.com/t/ekasatria/views/AdminInsightsStarter/Overview'
            token='eyJraWQiOiI3ZDNkYTYyNi1kZGY5LTQ4N2QtODc4MS05NmE1MGE4ZTU3MzAiLCJpc3MiOiJlNTM5MGRjNC1kMzgxLTQ5MzktYTJmNi1kYWJmZDE4NzE0NGMiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJla2Euc20xQHNpbmFybXV0aWFyYWNlbGwuY29tIiwiYXVkIjoidGFibGVhdSIsInNjcCI6InRhYmxlYXU6dmlld3M6ZW1iZWQiLCJqdGkiOiJ5b3VyLTI1Ni1iaXQtc2VjcmV0IiwiZXhwIjoxNjc0MjAxMzc0NTkwfQ.EWAeXUlvQlHRMT6jxs0PUHsmR3Msq5Ow_GihCPPjBBA'>
        </tableau-viz> -->
    </div>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            counts: {
                send_back: {
                    pending: "...",
                    otw: "..."
                },
                invoice: {
                    draft: "...",
                    ongoing: "..."
                },
                inventory: {
                    pending: "...",
                    adj: "...",
                    req_lost: "..."
                }
            },

            filter: {
                noFaktur: "",
                imeiSn: "",
                branch: ""
            },

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "no_faktur_pgi", label: "No. Faktur PGI", sortable: true },
                { key: "imei_sn", label: "IMEI / SN", sortable: true },
                { key: "branch", label: "Cabang", sortable: true },
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            catalogLogs: [],
            roleId: null,

            catalogDivision: -1,
            catalogOffice: -1,

            startDateLengkap: null,
            endDateLengkap: null,
            catalogCountLengkap: 0,

            startDateBatangan: null,
            endDateBatangan: null,
            catalogCountBatangan: 0,

            optDivision: [],
            optOffice: [],
        }
    },
    methods: {

        init() {

            this.initStatus = 1

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                res.data.data.unshift({id: -1, name: "Semua"})
                this.optDivision = res.data.data
            })
            
            let getOffices = this.$axios.get("master/offices").then(res => {
                res.data.data.unshift({id: -1, name: "Semua"})
                this.optOffice = res.data.data
            })

            let getCountDashboard = this.$axios.get("dashboard").then(res => {
                this.counts = res.data.data
            })

            let getCatalogLog = this.$axios.get("dashboard/catalog-log?count=5").then(res => {
                this.catalogLogs = res.data.data
            })

            let getItems = this.getItems()

            Promise.all([getItems, getDivisions, getOffices, getCountDashboard, getCatalogLog]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                if(this.error.status == '401'){
                    return
                }
                this.initStatus = -1
                this.$helper.toastError(this, "Terjadi kesalahan pada sistem, mohon mencoba untuk refresh / logout dan login kembali, sebelum menghubungi team IT.")
            })
        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn
            }

            if(!this.$helper.isBlank(this.filter.branch)) {
                param += "&filterBranch=" + this.filter.branch
            }
            
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("dashboard/pending"+ param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("dashboardFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        prepareUpdate() {

            this.$axios.get("dashboard/catalog-log?count=5").then(res => {
                this.catalogLogs = res.data.data
            })

            this.clearUpdateCatalog()

            this.$bvModal.show('m-update')
        },

        clearUpdateCatalog() {
            this.startDateLengkap = null
            this.endDateLengkap = null
            this.startDateBatangan = null
            this.endDateBatangan = null
            this.catalogCountBatangan = 0
            this.catalogCountLengkap = 0
        },

        confirmUpdate() {

            if(this.catalogCountBatangan <= 0 && this.catalogCountLengkap <= 0){
                this.$helper.toastError(this, "Tidak ada item baru yang berstatus READY atau RETUR untuk ditampilkan ke katalog!")
                return
            }

            if(!this.$helper.isBlank(this.startDateLengkap) && this.$helper.isBlank(this.endDateLengkap)){
                this.$helper.toastError(this, "Tanggal approve barang lengkap harus diisi terlebih dahulu")
                return
            }

            if(this.$helper.isBlank(this.startDateLengkap) && !this.$helper.isBlank(this.endDateLengkap)){
                this.$helper.toastError(this, "Tanggal approve barang lengkap harus diisi terlebih dahulu")
                return
            }

            if(!this.$helper.isBlank(this.startDateBatangan) && this.$helper.isBlank(this.endDateBatangan)){
                this.$helper.toastError(this, "Tanggal approve barang batangan harus diisi terlebih dahulu")
                return
            }

            if(this.$helper.isBlank(this.startDateBatangan) && !this.$helper.isBlank(this.endDateBatangan)){
                this.$helper.toastError(this, "Tanggal approve barang batangan harus diisi terlebih dahulu")
                return
            }

            let isConfirmed = confirm("Anda yakin ingin melakukan update katalog? Proses ini tidak dapat dibatalkan!")
            if(!isConfirmed) return

            this.isBusy = true
            let payload = {
                startDateBatangan: this.startDateBatangan,
                endDateBatangan: this.endDateBatangan,
                startDateLengkap: this.startDateLengkap,
                endDateLengkap: this.endDateLengkap,
                divisionId: this.catalogDivision,
                officeId: this.catalogOffice,
            }
            this.$axios.post("dashboard/catalog", payload).then(res => {

                this.$helper.toastSuccess(this, "Katalog publik berhasil diupdate!")
                this.$bvModal.hide("m-update")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isBusy = false)

        },

        runCountCatalogLengkap() {

            if(!this.$helper.isBlank(this.startDateLengkap) && !this.$helper.isBlank(this.endDateLengkap)){
                this.$axios.get("dashboard/catalog-count?startDate="+this.startDateLengkap+"&endDate="+this.endDateLengkap+"&batangan=0&divisionId="+this.catalogDivision+"&officeId="+this.catalogOffice).then(res => {
                    this.catalogCountLengkap = res.data.data
                })
                .catch(error => this.$helper.parseError(this, error))
            }

        },

        runCountCatalogBatangan() {

            if(!this.$helper.isBlank(this.startDateBatangan) && !this.$helper.isBlank(this.endDateBatangan)){
                this.$axios.get("dashboard/catalog-count?startDate="+this.startDateBatangan+"&endDate="+this.endDateBatangan+"&batangan=1&divisionId="+this.catalogDivision+"&officeId="+this.catalogOffice).then(res => {
                    this.catalogCountBatangan = res.data.data
                })
                .catch(error => this.$helper.parseError(this, error))
            }

        },

        onClickShowCatalog() {
            window.open('https://katalog.sinarmutiaracell.com')
        }

    },
    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listAdjustmentBarcodeFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("dashboardFilter"))
        }
        this.roleId = localStorage.getItem('roleId')
        this.init()
    }, mounted() {
        // document.getElementById("refresh").click()
    }
}
</script>
